import {
  CREATE_PASSAGE_REQUEST,
  CREATE_PASSAGE_SUCCESS,
  CREATE_PASSAGE_FAILURE,
  FETCH_PASSAGES_REQUEST,
  FETCH_PASSAGES_SUCCESS,
  FETCH_PASSAGES_FAILURE,
  UPDATE_PASSAGE_REQUEST,
  UPDATE_PASSAGE_SUCCESS,
  UPDATE_PASSAGE_FAILURE,
  DELETE_PASSAGE_REQUEST,
  DELETE_PASSAGE_SUCCESS,
  DELETE_PASSAGE_FAILURE
} from './PassageTypes';

const initialState = {
  passages: [],
  loading: false,
  error: null
};

export const passageReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PASSAGE_REQUEST:
    case FETCH_PASSAGES_REQUEST:
    case UPDATE_PASSAGE_REQUEST:
    case DELETE_PASSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_PASSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        passages: [...state.passages, action.payload],
        error: null
      };

    case FETCH_PASSAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        passages: action.payload,
        error: null
      };

    case UPDATE_PASSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        passages: state.passages.map(passage =>
          passage.passageId === action.payload.passageId ? { ...passage, ...action.payload } : passage
        ),
        error: null
      };

    case DELETE_PASSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        passages: state.passages.filter(passage => passage.passageId !== action.payload),
        error: null
      };

    case CREATE_PASSAGE_FAILURE:
    case FETCH_PASSAGES_FAILURE:
    case UPDATE_PASSAGE_FAILURE:
    case DELETE_PASSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
